import { render, staticRenderFns } from "./SectionPopular.vue?vue&type=template&id=0602c16c&scoped=true&"
import script from "./SectionPopular.vue?vue&type=script&lang=ts&"
export * from "./SectionPopular.vue?vue&type=script&lang=ts&"
import style0 from "./SectionPopular.vue?vue&type=style&index=0&id=0602c16c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0602c16c",
  null
  
)

export default component.exports